import { render } from "./NoDataCus.vue?vue&type=template&id=3941c6c3"
import script from "./NoDataCus.vue?vue&type=script&lang=js"
export * from "./NoDataCus.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__